import useLenis from '@/hooks/useLenis';
import Header from '@/components/scorpion/Header';
import Hero from '@/components/scorpion/Hero';
import Marquee from '@/components/scorpion/Marquee';
import Stats from '@/components/scorpion/Stats';
import Services from '@/components/scorpion/Services';
import Manifesto from '@/components/scorpion/Manifesto';
import Process from '@/components/scorpion/Process';
import Testimonials from '@/components/scorpion/Testimonials';
import Apply from '@/components/scorpion/Apply';
import Faq from '@/components/scorpion/Faq';
import Footer from '@/components/scorpion/Footer';
import ChatWidget from '@/components/scorpion/ChatWidget';

export default function Landing() {
  useLenis();
  return (
    <main className="relative bg-[#050505] text-[#f5f5f0]">
      <Header />
      <Hero />
      <Marquee />
      <Stats />
      <Services />
      <Manifesto />
      <Process />
      <Testimonials />
      <Apply />
      <Faq />
      <Footer />
      <ChatWidget />
    </main>
  );
}
